import angular from 'angular';

import '@client/core/components/utilities/tooltip';

import { RateTooltipComponent } from './rate-tooltip.component';

angular
  .module('app.global.dashboard-component-library.rate-tooltip', ['core.components.tooltip'])
  .component('esRateTooltip', RateTooltipComponent);
